var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useState, useCallback, useMemo, useRef, } from 'react';
import { accountApi } from '../../api/common/account';
import { DrawerEventListeners } from '../../utils/DrawerEventUtils';
var InfoOffersContext = createContext(null);
var InfoOffersProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), perksInfo = _b[0], setPerksInfo = _b[1];
    var _c = useState(false), hasError = _c[0], setHasError = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var activeRequestRef = useRef(false);
    var _e = React.useState(false), openOfferModal = _e[0], setOpenOfferModal = _e[1];
    var _f = React.useState(0), currentOffer = _f[0], setCurrentOffer = _f[1];
    var _g = React.useState([]), offerList = _g[0], setOfferList = _g[1];
    var _h = React.useState(''), slideDirection = _h[0], setSlideDirection = _h[1];
    var _j = React.useState(true), hideAnimation = _j[0], setHideAnimation = _j[1];
    var finishOfferLoad = useCallback(function (infoData) {
        if (infoData) {
            var nonProgramPerks = infoData === null || infoData === void 0 ? void 0 : infoData.nonProgramPerks;
            var previousYearPerks = infoData === null || infoData === void 0 ? void 0 : infoData.previousYearPerks;
            if (nonProgramPerks !== undefined && previousYearPerks !== undefined) {
                // Handle sorting/ordering
                var startingList = __spreadArray(__spreadArray([], nonProgramPerks, true), previousYearPerks, true);
                var offersOnly = startingList.filter(function (item) { return item.offerType === 'OFFER'; });
                var splitList = {
                    giftCards: offersOnly.filter(function (item) { return !!item.giftCard; }),
                    nonGiftCards: offersOnly.filter(function (item) { return !item.giftCard; }),
                };
                var mergedList = __spreadArray(__spreadArray([], splitList.giftCards, true), splitList.nonGiftCards, true);
                var activeList = __spreadArray([], mergedList, true).filter(function (offer) {
                    return offer.perkStatus === 'ACTIVE' || offer.perkStatus === 'UNCLAIMED';
                });
                var sortedList = activeList.sort(function (ap, bp) {
                    return ap.daysLeft - bp.daysLeft;
                });
                setOfferList(sortedList);
            }
        }
    }, []);
    var getPerksInfoOffersData = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var infoData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Prevent duplicate concurrent requests
                    if (activeRequestRef.current) {
                        return [2 /*return*/];
                    }
                    activeRequestRef.current = true;
                    return [4 /*yield*/, accountApi
                            .perksInfoOffersDetails()
                            .then(function (data) {
                            if ((data === null || data === void 0 ? void 0 : data.errors) || !(data === null || data === void 0 ? void 0 : data.customerAccountId)) {
                                return setHasError(true);
                            }
                            return data;
                        })
                            .finally(function () {
                            activeRequestRef.current = false;
                        })];
                case 1:
                    infoData = _a.sent();
                    setPerksInfo(function () { return infoData; });
                    finishOfferLoad(infoData);
                    setIsLoading(function () { return false; });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var refreshOffers = useCallback(function () {
        setHasError(false);
        setIsLoading(function () { return true; });
        getPerksInfoOffersData();
    }, []);
    DrawerEventListeners.useInfoOffersActivateListeners(refreshOffers);
    return (React.createElement(InfoOffersContext.Provider, { value: useMemo(function () { return ({
            hasError: hasError,
            setHasError: setHasError,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            perksInfo: perksInfo,
            getPerksInfoOffersData: getPerksInfoOffersData,
            setPerksInfo: setPerksInfo,
            openOfferModal: openOfferModal,
            setOpenOfferModal: setOpenOfferModal,
            currentOffer: currentOffer,
            setCurrentOffer: setCurrentOffer,
            offerList: offerList,
            setOfferList: setOfferList,
            finishOfferLoad: finishOfferLoad,
            refreshOffers: refreshOffers,
            slideDirection: slideDirection,
            setSlideDirection: setSlideDirection,
            hideAnimation: hideAnimation,
            setHideAnimation: setHideAnimation,
        }); }, [
            isLoading,
            slideDirection,
            hideAnimation,
            openOfferModal,
            currentOffer,
        ]) }, children));
};
export { InfoOffersProvider, InfoOffersContext };
